import { createSlice } from "@reduxjs/toolkit";
const CountrySlice = createSlice({
  name: "CountrySlice",
  initialState: {
    isLoading: false,
    countryData: [],
    stateData: [],
    cityData: [],
  },
  reducers: {
    /////// COUNTRY REDUCERS START ////////
    CountryGetDataRequest: (state, action) => {
      return { ...state, isLoading: true };
    },
    CountryGetDataSuccess: (state, action) => {
          return { ...state, isLoading: false, countryData: action.payload }
    },
    CountryGetDataFailure: (state, action) => {
      return { ...state, isLoading: false };
    },
    /////// COUNTRY REDUCERS END ////////

    /////// STATE REDUCERS START ////////
    StateGetDataRequest: (state, action) => {
      return { ...state, isLoading: true };
    },
    StateGetDataSuccess: (state, action) => {
      return { ...state, isLoading: false, stateData: action.payload };
    },
    StateGetDataFailure: (state, action) => {
      return { ...state, isLoading: false };
    },
    /////// STATE REDUCERS END ////////

    /////// CITY REDUCERS START ////////
    CityGetDataRequest: (state, action) => {
      return { ...state, isLoading: true };
    },
    CityGetDataSuccess: (state, action) => {
      return { ...state, isLoading: false, cityData: action.payload };
    },
    CityGetDataFailure: (state, action) => {
      return { ...state, isLoading: false };
    },
    /////// CITY REDUCERS END ////////
  },
});
export const {
  CountryGetDataRequest,
  CountryGetDataSuccess,
  CountryGetDataFailure,
  StateGetDataRequest,
  StateGetDataSuccess,
  StateGetDataFailure,
  CityGetDataRequest,
  CityGetDataSuccess,
  CityGetDataFailure,
} = CountrySlice.actions;
export default CountrySlice.reducer;
